<template>
  <Modal v-model="connectionLost">
    <p class="pb-2 text-lg font-bold leading-tight xl:text-2xl">
      {{ $t('popups.lostConnection.title') }}
    </p>
    <p class="pb-5 text-sm leading-tight xl:pb-8">
      {{ $t('popups.lostConnection.description', brandInfo) }}
    </p>
    <div class="flex">
      <a
        :href="backToLHLink"
        class="inline-flex items-center justify-center w-full py-2 text-xs font-normal cursor-pointer btn-secondary max-w-55 xl:text-base"
      >
        {{ $t('popups.lostConnection.returnToLHButton', brandInfo) }}
      </a>
    </div>
  </Modal>
</template>

<script>
import LostConnectionPopup from '~app/psp/base/lost-connection-popup.ts'
import Modal from '~brand-components/lufthansa/modal/modal.vue'

export default LostConnectionPopup.extend({
  components: {
    Modal,
  },
})
</script>
